import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { testimonialApis } from "../../../Data/axios";
import ReusableTable from "../ReusableTable";
import FadeInSection from "../../../Components/FadeInSection";
import config from "../../../Data/AuthUser.js";
import DashboardTestimonialsEdit from "./DashboardTestimonialsEdit.jsx";
import DashboardTestimonialsViewMore from "./DashboardTestimonialsViewMore.jsx";
const DashboardTestimonials = () => {
  const IMAGE_API_URL = config.apiImageUrl;
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const [testimonials, setTestimonials] = useState([]); // Initialize as an empty array
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [queries, setQueries] = useState({
    page: 1,
    per_page: 10,
  });
  const [newTestimonial, setNewTestimonial] = useState({
    name: "",
    image: "",
    description: "",
    status: 1, // Defaults to '1: active'
    tag: "",
    rating: 1,
  });
  const [filters, setFilters] = useState({
    status: "",
  });
  const headers = [
    { key: "id", label: "ID", sortable: true },
    { key: "author", label: "Author", sortable: true },
    { key: "name", label: "Name", sortable: true },
    { key: "image", label: "Image", sortable: false },
    { key: "description", label: "Description", sortable: false },
    { key: "status", label: "Status", sortable: true },
    { key: "tag", label: "Tag", sortable: false },
    { key: "rating", label: "Rating", sortable: true },
  ];

  const data = testimonials.map((testimonial) => ({
    id: testimonial.id,
    name: testimonial.name,
    image: (
      <img
        src={`${IMAGE_API_URL}${testimonial.image}`}
        alt={"null"}
        className="w-10 h-10 object-cover"
      />
    ),
    description: testimonial.description
      ? testimonial.description.substring(0, 25) +
        (testimonial.description.length > 25 ? "..." : "")
      : "",
    status: testimonial.status === 1 ? "Active" : "Inactive",
    tag: testimonial.tag,
    rating: testimonial.rating,
    author: (
      <div className="flex items-center gap-3">
        {testimonial && testimonial.created_by_image && (
          <img
            src={`${IMAGE_API_URL}${testimonial.created_by_image}`}
            alt={testimonial?.created_by_name || "Creator"}
            className="w-10 h-10 rounded-full object-cover"
          />
        )}
        <div>
          <div>{testimonial.created_by_name}</div>
          {testimonial && testimonial.created_by_name && (
            <div className="text-xs text-gray-500">
              {testimonial.created_by_role}
            </div>
          )}
        </div>
      </div>
    ),
    creator: {
      name: testimonial?.created_by_name || "Name",
      image: testimonial?.created_by_image || null,
      role: testimonial?.created_by_role || "Role",
      role_name: testimonial?.created_by_rolename || "Unknown",
    },
    rawData: testimonial,
  }));

  // Fetch testimonials from the API
  const fetchData = async (filterOverrides = null) => {
    try {
      // Use filterOverrides if provided, otherwise use the filters from state
      const currentFilters = filterOverrides || filters;

      // Combine queries and filters into a single parameters object
      const params = {
        ...queries,
        ...(currentFilters.status && { status: currentFilters.status }),
        ...(currentFilters.type && { type: currentFilters.type }),
      };

      console.log("Fetching with parameters:", params);
      const response2 = await testimonialApis.getDashboardTestimonials(params);
      console.log("res2,", response2);
      // console.log("res1", response);
      setTestimonials(response2?.data.data || []);
    } catch (err) {
      setError(err.message || "Failed to fetch testimonials");
      console.log("Error fetching testimonials:", err);
    } finally {
      setLoading(false);
    }
  };

  const refreshData = async () => {
    setLoading(true);
    fetchData();
  };

  useEffect(() => {
    refreshData();
  }, []);

  useEffect(() => {
    refreshData();
  }, [queries, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    console.log(`Filter changed: ${name} = ${value}`);
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const clearFilters = () => {
    console.log("Clearing filters");
    setFilters({
      status: "",
    });
  };
  const onPageChange = (newPage) => {
    setQueries((prev) => ({ ...prev, page: newPage }));
  };

  const onPerPageChange = (newPerPage) => {
    setQueries((prev) => ({ ...prev, per_page: newPerPage }));
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files?.length > 0) {
      setNewTestimonial((prev) => ({ ...prev, image: files[0] })); // Store the file
    } else {
      setNewTestimonial((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleTableAction = (action, rowData) => {
    console.log("Table action received:", action, rowData);
    
    if (action === 'view') {
      // Ensure we're getting the complete data
      const testimonialData = rowData.rawData || rowData;
      console.log("Opening view modal with data:", testimonialData);
      setSelectedTestimonial(testimonialData);
      setShowViewModal(true);
    } 
    else if (action === 'edit') {
      const testimonialData = rowData.rawData || rowData;
      console.log("Opening edit modal with data:", testimonialData);
      setSelectedTestimonial(testimonialData);
      setShowEditModal(true);
    } 
    else if (action === 'delete') {
      const testimonialId = rowData.id || (rowData.rawData && rowData.rawData.id);
      if (testimonialId) {
        handleDelete(testimonialId);
      } else {
        console.error("Could not find ID for deletion");
      }
    }
  };
  
  // Add this function to handle edit save
  const handleEditSave = async (updatedData) => {
    try {
      setLoading(true);
      await testimonialApis.updateById(selectedTestimonial.id, updatedData);
      setShowEditModal(false);
      await refreshData();
    } catch (error) {
      console.error("Failed to update testimonial:", error);
      setError("Failed to update testimonial: " + (error.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };
  
  // Add this function to handle delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      try {
        setLoading(true);
        await testimonialApis.deleteById(id);
        await refreshData();
      } catch (error) {
        console.error("Failed to delete testimonial:", error);
        setError("Failed to delete testimonial: " + (error.message || "Unknown error"));
      } finally {
        setLoading(false);
      }
    }
  };

  const handleAddTestimonial = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("name", newTestimonial.name);
      formData.append("image", newTestimonial.image); // Append the file
      formData.append("description", newTestimonial.description);
      formData.append("status", newTestimonial.status);
      formData.append("tag", newTestimonial.tag);
      formData.append("rating", newTestimonial.rating);
      await testimonialApis.add(formData);
      await fetchData();
      setShowModal(false);
    } catch (err) {
      setError(err.message || "Failed to add new testimonial");
      console.error("Error adding testimonial:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-10">Loading...</div>;
  if (error)
    return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <div className="bg-gray-200 min-h-screen text-black">
      {/* Filter Bar - Full width, separate container */}
      <div className="w-full bg-white shadow-sm mb-6">
        <div className="container mx-auto py-3 px-4">
          <div className="flex flex-col md:flex-row gap-3 md:items-center">
            <div className="flex items-center">
              <label className="text-sm font-medium text-gray-500 mr-2">
                Status:
              </label>
              <select
                name="status"
                className="border rounded p-1.5 text-gray-800 text-sm"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="">All Status</option>
                <option value="1">Active</option>
                <option value="2">Inactive</option>
              </select>
            </div>
            <div className="flex items-center">
            <label className="text-sm font-medium text-gray-500 mr-2">From:</label>
            <input
              type="date"
              name="start_date"
              className="border rounded p-1.5 text-gray-800 text-sm"
            />
          </div>
          <div className="flex items-center">
            <label className="text-sm font-medium text-gray-500 mr-2">To:</label>
            <input
              type="date"
              name="end_date"
              className="border rounded p-1.5 text-gray-800 text-sm"
            />
          </div>

            <button
              type="button"
              className="ml-auto bg-gray-100 text-gray-600 px-3 py-1.5 rounded text-sm hover:bg-gray-200"
              onClick={clearFilters}
            >
              Clear Filters
            </button>
          </div>

          
        </div>
      </div>
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-4 md:mx-6 mt-1">
          <h1 className="text-2xl font-bold font-ubuntu">Testimonials</h1>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            onClick={() => setShowModal(true)}
          >
            Add Testimonial
          </button>
        </div>

        <div className="h-[50vh]">
          <ReusableTable
            headers={headers}
            data={data}
            rowKey="id"
            defaultSortKey="id"
            tableClassName=""
            headerClassName="text-gray-700"
            rowClassName="hover:bg-gray-200"
            tableApis={testimonialApis}
            onTableUpdate={refreshData}
            onPageChange={onPageChange}
            onPerPageChange={onPerPageChange}
            queries={queries}
            type="testimonials"
            onAction={handleTableAction}
          />
        </div>

        {showModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-[0vw] md:w-1/6"></div>
            <div className="bg-white p-6 rounded shadow-lg w-full md:w-[85vw] h-[88vh] flex flex-col">
              <h2 className="text-lg font-semibold text-gray-800 mb-4 text-center">
                Add New Testimonial
              </h2>
              <div className="border-t border-gray-200 mb-6"></div>
              <form
                className="flex flex-col space-y-8 flex-grow"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleAddTestimonial();
                }}
              >
                <div className="flex">
                  <p className="text-sm font-medium text-gray-500 w-1/3">
                    Name
                  </p>
                  <input
                    className="w-2/3 border rounded p-2 text-gray-800"
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={newTestimonial.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="flex">
                  <p className="text-sm font-medium text-gray-500 w-1/3">
                    Image
                  </p>
                  <input
                    type="file"
                    name="image"
                    accept="image/jpeg, image/png, image/jpg, image/gif"
                    onChange={handleInputChange}
                    className="w-2/3 border rounded p-2 text-gray-800"
                    required
                  />
                </div>
                <div className="flex">
                  <p className="text-sm font-medium text-gray-500 w-1/3">
                    Description
                  </p>
                  <textarea
                    className="w-2/3 border rounded p-2 text-gray-800"
                    rows="3"
                    name="description"
                    placeholder="Description"
                    value={newTestimonial.description}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="flex">
                  <p className="text-sm font-medium text-gray-500 w-1/3">Tag</p>
                  <input
                    className="w-2/3 border rounded p-2 text-gray-800"
                    type="text"
                    name="tag"
                    placeholder="Tag"
                    value={newTestimonial.tag}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="flex">
                  <p className="text-sm font-medium text-gray-500 w-1/3">
                    Rating
                  </p>
                  <input
                    className="w-2/3 border rounded p-2 text-gray-800"
                    type="number"
                    name="rating"
                    placeholder="Rating"
                    value={newTestimonial.rating}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-6 flex justify-start space-x-4">
                  <button
                    type="button"
                    className="px-4 py-2 bg-gray-100 text-gray-600 rounded-lg"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                  >
                    Add
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {showViewModal && selectedTestimonial && (
          <DashboardTestimonialsViewMore 
            data={selectedTestimonial.rawData || selectedTestimonial} 
            onClose={() => setShowViewModal(false)} 
          />
        )}
        
        {showEditModal && selectedTestimonial && (
          <DashboardTestimonialsEdit 
            data={selectedTestimonial.rawData || selectedTestimonial}
            onClose={() => setShowEditModal(false)}
            onSave={handleEditSave}
          />
        )}
      </div>
    </div>
  );
};

export default DashboardTestimonials;
